import { ReactTFC } from "../../utils/fp/missing-ts-parts";
import { css } from "@emotion/react";
import { CloseButtonSvg } from "../../assets";
import React from "react";
import { CSS_COLORS } from "../../styles/styles-css-variables";

export const ModelCloseButton: ReactTFC<{ onClick: () => void }> = props => {
  return (
    <button
      type={"button"}
      onClick={props.onClick}
      css={css`
        width: 36px;
        height: 36px;

        position: absolute;

        @media (pointer: coarse) {
          top: 6px;
          right: 6px;
        }

        right: 6px;
        top: 12px;

        z-index: 3;

        display: block;
        color: ${CSS_COLORS.White};
      `}
    >
      <CloseButtonSvg
        css={css`
          width: 100%;
          height: 100%;
        `}
      />
    </button>
  );
};
